import { LeftOutlined } from '@ant-design/icons';
import { ButtonProps } from 'antd';
import IconButton from './IconButton';

type Props = ButtonProps;

export default function BackButton(props: Props) {
  return <IconButton {...props} tooltip="Voltar" icon={<LeftOutlined />} />;
}
